import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

import { Button, Translate } from '@hydra/common/components';

import { useI18n } from '@hydra/common/customHooks';
import { sendEvent } from '@hydra/utils/gtm';

const useStyles = makeStyles(theme => ({
  text: {
    paddingBottom: theme.spacing(1),
    '& ul': {
      display: 'flex',
      justifyContent: 'center',
      marginTop: theme.spacing(1),
      '& li': {
        marginRight: theme.spacing(3.5)
      }
    }
  }
}));

export default function ReviewCriteriaCTA ({ text, event }: { text: JSX.Element, event: string }) {
  const { locale } = useI18n();
  const classes = useStyles();
  return (
    <>
      <div className={classes.text}>{text}</div>
      <Button
        size='medium'
        color='success'
        variant='contained'
        href={`/${locale}/signup?plan=v2pro`}
        rel='nofollow noopener noreferrer'
        target='_blank'
        onClick={() => sendEvent(`freereview-teasercrit-${event}-register-btn`)}
      >
        <Translate content='crit_cta_start_free_trial' />
      </Button>
    </>
  );
}
